import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FloatingInputComponent } from '@shared/components/ui/floating-input';
import { HorusBtnDirective } from '../../../../shared/directives/horus-btn.directive';
import { AuthState } from '../../services/auth.state';
import { HorusLoadingComponent } from '@shared/components/domain/horus-loading/horus-loading.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FloatingInputComponent,
    HorusBtnDirective,
    HorusLoadingComponent,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  readonly authState = inject(AuthState);
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);

  readonly forgotPasswordForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  onSubmit(): void {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const { email } = this.forgotPasswordForm.value;
    this.authState.sendPasswordResetEmail(email);
  }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }

  get emailInvalid(): boolean {
    const email = this.forgotPasswordForm.get('email');
    return !!(email?.invalid && email?.touched);
  }
}